import React, { useEffect } from 'react';
import '../../shared/styles/our-purpose.css';
import { PurposeAccordion } from '../../shared/components/PurposeAccordion';
import { SEO } from '../../shared/components/SEO';

export default function ForOurPlanet() {
  useEffect(() => {
    document.body.classList.add('loaded');
    document.body.classList.add('zfast-theme-page');
    return () => {
      document.body.classList.remove('loaded');
      document.body.classList.remove('zfast-theme-page');
    };
  }, []);

  return (
    <>
      <SEO 
        title="For Our Planet | ZFAST Agritech India" 
        description="Discover ZFAST Agritech India's commitment to sustainability, environmental footprint reduction, eco-friendly cattle & pig feed production, and resource protection." 
        path="/for-our-planet" 
      />
      <div className="zfast-clone-wrapper zfast-theme-page" dangerouslySetInnerHTML={{ __html: `
<div data-barba="container">
<header class="header--big">
<div class="header-background background--image">
<img alt="Our planet environmental landscape" class="header-background__image" loading="eager" width="1920" height="600" src="/images/about/our-planet.webp"/>
<div class="show-overlay"></div>
</div>
<div class="header-text">
<div class="container">
<div class="col-12 col-lg-8 offset-lg-2">
<div class="header-text-titles">
<h1>for our planet</h1>
</div>
</div>
</div>
</div>
</header>
<section class="content-wrapper" id="content" role="main">
<div class="content-wrapper">
<article class="post-type-page" id="post-454">
<section class="article-content">
<div class="article-body">
<section class="block__body-text color__black background__white block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-large block-padding-left-no block-padding-right-no block-padding-bottom-no" style="">
<div class="container">
<div class="row">
<div class="col-12 col-lg-8 offset-lg-2">
<div class="row order-1 order-lg-2">
<div class="col-12">
</div>
<div class="col-12 col-lg-8 order-3 order-lg-2">
<div class="content">
<p>Sustainability plays a key role in our purpose at ZFAST Agritech India. We are continuously looking to the outside world to understand current and future environmental trends. By championing Extended Producer Responsibility (EPR) and integrating circular economy principles into our agricultural operations, we aim to minimize plastic waste, promote eco-friendly packaging, and protect the local ecosystems of India.</p>
</div>
</div>
<div class="col-12 col-lg-4 order-1 order-lg-3">
<div class="container d-flex logo-container">
<img alt="EPR Planet conservation icon" decoding="async" loading="lazy" width="1024" height="1024" src="/images/home/zfast-poultry-feed-premium.webp"/>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="block__image-number block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-no block-padding-left-no block-padding-right-no block-padding-bottom-no">
<div class="container-fluid block__image-number--container-outer" style="background-image: url(${'/images/about/our-planet.webp'});">
<div class="container">
<div class="row">
<div class="col-12 col-md-6 col-xl-5">
<div class="block__image-number--container-inner">
<div class="block__image-number--counter"><span class="block__image-number--number">1</span></div>
<h2 class="block__image-number--title">Efforts to make our supply chain futureproof </h2>
<p class="block__image-number--content">Aiming to execute sustainable sourcing, production and distribution of our products and services</p>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="block__body-text color__black background__white block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-large block-padding-left-no block-padding-right-no block-padding-bottom-large" style="">
<div class="container">
<div class="row">
<div class="col-12 col-lg-8 offset-lg-2">
<div class="row order-1 order-lg-2">
<div class="col-12">
<div class="content">
<p class="~a10" id="+a10*c724[a0*b14[a0*]b38]c754[a10*b14[a0*]b39[a2*]b25[a10*]b24]c134|x0">At ZFAST Agritech India, we understand that building a future-proof supply chain goes hand in hand with environmental stewardship. By optimizing our logistics networks and partnering with local farmers for sustainable sourcing, we minimize transportation inefficiencies and reduce resource waste.</p>
<p>This strategic approach to our agritech supply naturally translates into a more efficient, eco-friendly operation that directly lowers our overall environmental impact, benefiting both our agricultural partners and the planet.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="block__image-number block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-no block-padding-left-no block-padding-right-no block-padding-bottom-no">
<div class="container-fluid block__image-number--container-outer" style="background-image: url(${'/images/about/zfast-planet.webp'});">
<div class="container">
<div class="row">
<div class="col-12 col-md-6 col-xl-5 offset-md-6 offset-xl-7">
<div class="block__image-number--container-inner">
<div class="block__image-number--counter"><span class="block__image-number--number">2</span></div>
<h2 class="block__image-number--title">Smaller footprint</h2>
<p class="block__image-number--content">To reduce Greenhouse Gas emission</p>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="block__body-text color__black background__white block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-large block-padding-left-no block-padding-right-no block-padding-bottom-large" style="">
<div class="container">
<div class="row">
<div class="col-12 col-lg-8 offset-lg-2">
<div class="row order-1 order-lg-2">
<div class="col-12">
<div class="content">
<p class="~a10" id="+a10*c724[a0*b14[a0*]b38]c754[a10*b14[a0*]b39[a2*]b25[a10*]b24]c134|x0">Reducing our greenhouse gas emissions is just one part of our broader commitment to ecological balance. As we work to lower the carbon footprint of our manufacturing facilities and transport networks, we also take direct responsibility for the physical footprint of our products.</p>
<p>By integrating sustainable energy practices with active waste reduction, we ensure that our dedication to the planet extends far beyond the factory gates, actively protecting the ecosystems that support Indian agriculture.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="block__image-number block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-no block-padding-left-no block-padding-right-no block-padding-bottom-no">
<div class="container-fluid block__image-number--container-outer" style="background-image: url(${'/images/about/zfast-community-development.webp'});">
<div class="container">
<div class="row">
<div class="col-12 col-md-6 col-xl-5">
<div class="block__image-number--container-inner">
<div class="block__image-number--counter"><span class="block__image-number--number">3</span></div>
<h2 class="block__image-number--title">Extended Producer Responsibility (EPR)</h2>
<p class="block__image-number--content">Actively managing our environmental footprint through robust plastic recycling and waste management initiatives across rural and urban India.</p>
</div>
</div>
</div>
</div>
</div>
</section>

</div>
</section>
</article>
</div><!-- /content-wrapper -->
</section>

</div>
` }} />
      <PurposeAccordion />
    </>
  );
}
